import { showToast } from "@certn/cascadia";
import { useTranslation } from "react-i18next";
import { BasicButton, Stack, TextField } from "@certn/cascadia-react";
import { css } from "@emotion/css";

import { WhatsThis } from "../../../components/WhatsThis";

interface Props {
  value: string;
  label: string;
}

export function CopiableReadonlyValue({ value, label }: Props) {
  const { t } = useTranslation();
  const copyToClipBoard = () => {
    navigator.clipboard.writeText(value);
    showToast(t("URL copied to clipboard"), { type: "success" });
  };

  return (
    <Stack orientation="horizontal" align="end" gap="space-2">
      <TextField
        className={styles.textFieldSpacing}
        testID="webhook-url"
        label={label}
        value={value}
        isDisabled
        isRequired
        info={
          <WhatsThis>
            {t(
              "Add this into the ‘{{label}}’ field in Workday’s API Clients.",
              { label }
            )}
          </WhatsThis>
        }
      />
      <BasicButton
        onPress={copyToClipBoard}
        type="button"
        size="medium"
        testID="copy-link-button"
        leftIcon="link"
      >
        {t("Copy link")}
      </BasicButton>
    </Stack>
  );
}

const styles = {
  textFieldSpacing: css({
    width: "440px !important",
  }),
};
